import { useEffect, useState } from "react";

const DocumentUploadModalBody = (props) => {
  const [directUploadStates, setDirectUploadStates] = useState({});

  useEffect(() => {
    const handleUploadState = (event) => {
      const detail = event.detail;
      if (!detail?.fileName) return;
      setDirectUploadStates((current) => ({
        ...current,
        [detail.fileName]: {
          ...current[detail.fileName],
          ...detail,
        },
      }));
    };
    window.addEventListener("pdf-upload-state", handleUploadState);
    return () => window.removeEventListener("pdf-upload-state", handleUploadState);
  }, []);

  useEffect(() => {
    if (props.uploadProgress === 100) {
      const timer = setTimeout(() => {
        props.hideModal();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [props]);
  const files = Array.isArray(props.uploadFile) ? props.uploadFile : [props.uploadFile];
  const fileName = (file) =>
    typeof file === "string" ? file : file?.name || file?.file?.name || "Document";
  const statusLabel = (state) => {
    if (!state) return "";
    if (state.status === "retrying") {
      return `Retrying part ${state.partNumber} (attempt ${state.attempt})`;
    }
    if (state.status === "failed") return state.error || "Upload failed";
    if (state.status === "cancelled") return "Upload cancelled";
    if (state.status === "finalizing") return "Finalizing document";
    if (state.status === "completed") return "Upload complete";
    if (state.status === "initiating") return "Preparing upload";
    return `Uploading${state.partNumber ? ` part ${state.partNumber}` : ""}`;
  };

  return (
    <div>
      <div className="modal-header justify-content-center" style={{ backgroundColor: "#19395f" }}>
        <div className="modal-header-wrap text-white text-center">
          <h5 className="modal-title text-white">Document Upload Progress:</h5>
          <p>
            All file names are truncated to be 16 characters long plus the file extension maximum.
          </p>
        </div>
      </div>
      <div className="modal-body height-300">
        <div id="file-previews">
          {files?.map((file, index) => {
            const name = fileName(file);
            const uploadState = directUploadStates[name];
            const progress = uploadState?.progress ?? props.uploadProgress;
            const canCancel =
              uploadState?.uploadToken &&
              !["completed", "failed", "cancelled"].includes(uploadState.status);
            return (
              <div key={`${name}-${index}`}>
                <div className="dz-preview dz-file-preview dz-processing dz-success dz-complete m-b-5">
                  <div className="dz-image">
                    <img data-dz-thumbnail="" />
                  </div>
                  <div className="dz-details">
                    <div className="dz-size">
                      <span data-dz-size="">
                        <strong /> MB
                      </span>
                    </div>
                    <div className="dz-filename">
                      <span data-dz-name="">{name}</span>
                    </div>
                  </div>
                  <div className="dz-progress">
                    <span
                      className="dz-upload"
                      data-dz-uploadprogress={progress}
                      style={{ width: progress + "%" }}
                    />
                  </div>
                  <div className="dz-error-message">
                    <span data-dz-errormessage="">{statusLabel(uploadState)}</span>
                  </div>
                  {canCancel && (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger mt-1"
                      onClick={() =>
                        window.dispatchEvent(
                          new CustomEvent("pdf-upload-cancel", {
                            detail: { uploadToken: uploadState.uploadToken },
                          })
                        )
                      }
                    >
                      Cancel
                    </button>
                  )}
                </div>
              </div>
            );
          })}{" "}
        </div>
      </div>
      <div className="modal-footer border-0 bg-white justify-content-end">
        <label className="popup-handle-label">
          <input type="checkbox" />
          Automatically Close Upload Confirmation Popup
        </label>
        <button onClick={props.hideModal} type="button" className="btn btn-success btn-file-close">
          Close
        </button>
      </div>
    </div>
  );
};

export default DocumentUploadModalBody;
